import { traditional } from './traditional';
import { patriotic } from './patriotic';
import { modern } from './modern';
import { league } from './league';

export const rugby = {
  traditional,
  modern,
  patriotic,
  league,
};
